import authRules from '../authRules.js';

const addAssignmentViewDescription = (user) => {
  const { assignmentComment } = user.securityLevels;
  if (assignmentComment >= authRules.addAssignmentViewDescription.assignmentComment) {
    return true;
  } else {
    return false;
  }
}

export default addAssignmentViewDescription;
